import {
  loadBlockedDates,
  loadBookingsForAdmin,
  loadProducts,
  loadSettings,
} from '../data/repository'
import { GalleryImage } from '../data/types'
import { loadRemoteGalleryImages } from '../data/gallery'
export interface BackupData {
  version: number
  exportedAt: string
  data: {
    products: unknown[]
    bookings: unknown[]
    blockedDates: unknown[]
    settings: unknown
    gallery: GalleryImage[]
  }
}
export const exportBackup = async (): Promise<BackupData> => {
  const [products, bookings, blockedDates, settings, gallery] =
    await Promise.all([
      loadProducts(),
      loadBookingsForAdmin(),
      loadBlockedDates(),
      loadSettings(),
      loadRemoteGalleryImages(),
    ])
  return {
    version: 2,
    exportedAt: new Date().toISOString(),
    data: { products, bookings, blockedDates, settings, gallery },
  }
}
export const downloadBackup = async (): Promise<void> => {
  const backup = await exportBackup()
  const blob = new Blob([JSON.stringify(backup, null, 2)], {
    type: 'application/json',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `jumpland-supabase-backup-${new Date().toISOString().slice(0, 10)}.json`
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
